import { render } from "./Technos.vue?vue&type=template&id=0976d22e&scoped=true"
import script from "./Technos.vue?vue&type=script&lang=js"
export * from "./Technos.vue?vue&type=script&lang=js"

import "./Technos.vue?vue&type=style&index=0&id=0976d22e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0976d22e"]])

export default __exports__